<script>
  import { heroHeight, heroTextOptions, iterator } from "./utils/stores.js";
  import WistiaVideo from "./WistiaVideo.svelte";

  setInterval(function () {
    $iterator = $iterator + 1;
    if ($iterator == $heroTextOptions.length) {
      $iterator = 0;
    }
  }, 15000);
</script>

<style>
  .hero-wrapper-container {
    z-index: 90;
    position: relative;
    background-color: #1b2225;
  }
  .hero-container {
    margin: 0 5%;
    background-color: #1b2225;
    position: relative;
    overflow: hidden;
  }

  .hero-grid-wrapper {
    max-width: 1210px;
    margin: 0 auto;
    height: 769px;
    display: grid;
    grid-template-columns: repeat(15, [col] 1fr);
    grid-template-rows: repeat(30, [row] 25px);
    color: #1b2225;
    position: relative;
  }

  .casey-crawford-hero-image {
    grid-column: col 1 / span 1;
    width: 540px;
    z-index: 200;
    position: absolute;
    left: calc(70px + 2vw);
    bottom: 0px;
  }
  .hero-cc-background-logo {
    z-index: 100;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .hero-cc-background-logo img {
    width: 531px;
    height: 471px;
  }
  .space-container {
    width: 200px;
    grid-column: col 7 / span 1;
    grid-row: row 13;
    margin: 0 25px 0 140px;
  }
  .large-hero-text {
    z-index: 105;
    height: 100%;
    width: 70%;
    line-height: 13rem;
    grid-column: col 1 / span 10;
    grid-row: row 5;
    letter-spacing: 2.55rem;
    font-size: 145px;
    white-space: nowrap;
    font-family: 'Gotham A', 'Gotham B';
    font-weight: 800;
    font-style: normal;
  }
  .small-hero-text {
    z-index: 105;
    grid-column: col 9 / span 2;
    grid-row: row 14;
    line-height: 3rem;
    letter-spacing: 0.25rem;
    font-size: 26px;
    width: 100%;
    margin-left: 30%;
    white-space: nowrap;
    font-family: 'Gotham A', 'Gotham B';
    font-weight: 800;
    font-style: normal;
  }
  @media only screen and (max-width: 1920px) {
    .large-hero-text {
      font-size: calc(70px + 4vw);
    }
    .small-hero-text {
      font-size: calc(17px + 0.5vw);
    }
  }
  @media only screen and (max-width: 1024px) {
    .hero-container {
      overflow: visible;
    }
    .casey-crawford-hero-image {
      /* width: 33rem; */
      /* width: calc(-250px + 78vw); */
      /* min-width: 30rem; */
      left: calc(-700px + 80vw);
      /* right: calc(400px - 4vw); */
    }
    .space-container {
      display: none;
    }
    .large-hero-text {
      grid-column: col 1 / span 4;
      grid-row: row 8;
      line-height: 12rem;
      letter-spacing: 1rem;
      font-size: calc(77px + 2vw);
    }
    .small-hero-text {
      left: 10%;
      grid-column: col 14 / span 2;
      grid-row: row 3;
      width: 70%;
      font-size: 26px;
      padding-left: 50px;
      margin-left: 0;
    }
    .hero-cc-background-logo img {
      width: 401px;
      height: 356px;
    }
  }

  @media only screen and (max-width: 640px) {
    .hero-grid-wrapper {
      height: 568px;
    }
    .hero-container {
      overflow: visible;
    }
    .space-container {
      display: none;
    }
    .large-hero-text {
      display: none;
    }
    .small-hero-text {
      z-index: 205;
      grid-column: col 14 / span 2;
      grid-row: row 16;
      padding-left: 30px;
      width: auto;
    }
    .casey-crawford-hero-image {
      left: calc(-320px + 45vw);
      width: 26rem;
    }
    .hero-cc-background-logo img {
      width: calc(54vw);
      height: calc(48vw);
      min-width: 227px;
      min-height: 201px;
    }
  }
  @media only screen and (max-width: 400px) {
    .small-hero-text {
      padding-left: 0;
    }
    .casey-crawford-hero-image {
      left: -135px;
      width: 386px;
    }
    .hero-play-button-inner img {
      width: calc(-30px + 50vw);
    }
  }
  @media only screen and (max-width: 370px) {
    .hero-play-button-inner img {
      width: 150px;
    }
  }
</style>

<svelte:head>
  <script
    charset="ISO-8859-1"
    src="https://fast.wistia.com/assets/external/E-v1.js">

  </script>
  <script
    charset="ISO-8859-1"
    src="https://fast.wistia.com/assets/external/channel.js">

  </script>
</svelte:head>

<div class="hero-wrapper-container" bind:clientHeight={$heroHeight}>
  <div class="hero-cc-background-logo">
    <img src="/images/hero-cc-background-logo.svg" alt="cc-background-logo" />
  </div>

  <div class="hero-container">
    <div class="hero-grid-wrapper">
      <img
        class="grid-item casey-crawford-hero-image"
        src="/images/hero-casey-crawford-websize-update.png"
        alt="casey-crawford-hero" />
      <div
        class="grid-item large-hero-text"
        style="color:{$heroTextOptions[$iterator].color}">
        {@html $heroTextOptions[$iterator].text}
      </div>
      <div class="grid-item space-container" />
      <div
        class="grid-item small-hero-text"
        style="color:{$heroTextOptions[$iterator].color}">
        {@html $heroTextOptions[$iterator].text}
      </div>
      <WistiaVideo className="hero-play-button" wistiaSlug="hwg8wpbhob">
        <div class="grid-item hero-play-button-inner">
          <img src="images/hero-play-button.svg" alt="play-button" />
        </div>
      </WistiaVideo>
    </div>
  </div>
</div>
